import { Renderer2 } from '@angular/core';
import { MathService } from '../../mathematics/tool.math-service.service';
import { RectangleService } from '../rectangle/rectangle.service';
import { AbstractShape } from './abstract-shape';
import { Dimension } from './dimension';
import { Point } from './point';

export class Rectangle extends AbstractShape {

  constructor(
    protected renderer: Renderer2,
    public element: SVGElement,
    private mathService: MathService,
    protected rectangleService?: RectangleService
  ) {
      super(renderer, element, rectangleService);
    }

  insertRectangleInSVG(upLeftCorner: Point, dimension: Dimension): void {
    this.renderer.setAttribute(this.element, 'x', upLeftCorner.x.toString());
    this.renderer.setAttribute(this.element, 'y', upLeftCorner.y.toString());
    this.renderer.setAttribute(
      this.element,
      'width',
      dimension.width.toString()
    );
    this.renderer.setAttribute(
      this.element,
      'height',
      dimension.height.toString()
    );
  }

  dragRectangle(mouseDownPoint: Point, mouseMovePoint: Point, strokeWidth?: number): void {
    const dimensions = this.mathService.getRectangleSize(
      mouseDownPoint,
      mouseMovePoint,
      strokeWidth
    );
    const transformedPoint = this.mathService.getRectangleUpLeftCorner(
      mouseDownPoint,
      mouseMovePoint,
      strokeWidth
    );
    this.insertRectangleInSVG(transformedPoint, dimensions);
  }

  dragSquare(mouseDownPoint: Point, mouseMovePoint: Point, strokeWidth?: number): void {
    const transformedPoint = this.mathService.transformRectangleToSquare(
      mouseDownPoint,
      mouseMovePoint
    );
    const finalPoint = this.mathService.getRectangleUpLeftCorner(
      mouseDownPoint,
      transformedPoint,
      strokeWidth
    );
    const squareDimension = this.mathService.getRectangleSize(
      mouseDownPoint,
      transformedPoint,
      strokeWidth
    );
    this.insertRectangleInSVG(finalPoint, squareDimension);
  }
}
